import { Component, OnInit } from '@angular/core';
import { PrivilegeService } from "./../staff/Shared/privilege.service";


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(private privilegeService: PrivilegeService) { }

  MainmenuList: any[] = [];
  SubmenuList: any[] = [];

  html : any;

  ngOnInit() {
    this.SelectPrivilegeByRole(JSON.parse(localStorage.getItem("EmployeeData"))["RoleId"]);

    // this.html = '<h2>We're currently undergoing essential maintenance, we'll be back online shortly.</h2>
    // <p>If you have any questions please contact our customer services team via email at <a href="mailto:support@domain.com?subject=Support Requested">support@domain.com</a></p>'';

    this.html = ` <ul class='sidebar-menu'> `+
    ` <li class='menu-header'>Main Test</li> `+
    ` <li class='dropdown'> `

    // for (let i = 0; i < this.MainmenuList.length; i++) {
    
    //   `<a href="#" class='menu-toggle nav-link has-dropdown'>  `+
    //   `<i data-feather='monitor'></i><span>`+ 'this.MainmenuList[i].DocumentName' +`</span></a>  `

    // }
    +` <a href='#' class='menu-toggle nav-link has-dropdown'><i data-feather='layout'></i><span>`+ "12345" +`</span></a>`+

      +` <ul class='dropdown-menu'>  `+
    
      ` <li> <a [routerLink]='/customer'>customer</a> </li>` +
      ` <li><a [routerLink]='['/menu']' routerLinkActive='active'>Menu Test</a></li>` +
    
      ` </ul>  ` +
    ` </li>   `+
    ` </ul> ` ;
  
  }

  SelectPrivilegeByRole(RoleId: any){

    this.privilegeService.GetPrivilegebyRoleId(RoleId).toPromise()
    .then(data => {

      for (let i = 0; i < data.length; i++) {
        if (data[i].DocumentParentId == 0) {  

            this.MainmenuList.push(data[i]);
        }
      }

      for (let i = 0; i < data.length; i++) {
        if (data[i].DocumentParentId != 0) {  

            this.SubmenuList.push(data[i]);
        }
      }

      // console.log("this.MainmenuList");
      // console.log(this.MainmenuList.length);
      // // console.log(data);
      // // this.MainmenuList = data;
      // // this.DocumentList = data;
      // console.log("this.DocumentList");
      // console.log(this.DocumentList);

      // this.GetMenuHtml();

      // this.html = ` <ul class='sidebar-menu'> `+
      // ` <li class='menu-header'>Main Test</li> `+
      // `<li class='dropdown'> `
  
      // for (let i = 0; i < this.MainmenuList.length; i++) {
      
      //   `<a href="#" class='menu-toggle nav-link has-dropdown'>  `+
      //   `<i data-feather='monitor'></i><span>`+ this.MainmenuList[i].DocumentName +`</span></a>  `
  
      // }
  
      //   +`<ul class='dropdown-menu'>  `+
      
      //   `<li> <a [routerLink]='/customer'>customer</a> </li>` +
      //   `<li><a [routerLink]='['/menu']' routerLinkActive='active'>Menu Test</a></li>` +
      
      //   `</ul> ` +
      // `</li>  `+
      // `</ul>` ;
    })
    .catch(err => { console.log(err) });
  }

  // GetMenuHtml(): String{

    //  this.html = " <ul class='sidebar-menu'> "+
    //               " <li class='menu-header'>Main</li> "+
    //                   "<li class='dropdown'> " +
    //   "<a href='#' class='menu-toggle nav-link has-dropdown'>"+
    //   "<i  data-feather='monitor'></i><span>Dashboard</span></a>"+
    //     "<ul class='dropdown-menu'>"+
    //       "<li><a class='nav-link' routerLink='/customer' routerLinkActive='active'>customer</a></li>"+
    //       "<li><a [routerLink]='['/dashboard']' class='nav-link' >Home</a></li> "+          
    //       "<li><a [routerLink]='['/dashboard']' routerLinkActive='active'>dashboard</a></li>"+
    //       "<li><a [routerLink]='['/menu']' routerLinkActive='active'>Menu</a></li>" +
          
    //     "</ul>"+
    // "</li>" ;

//     this.html =  "<ul class='sidebar-menu'> "+
//   " <li class='menu-header'>Main Test</li> "+
//   "<li class='dropdown'> "+
//     "<a [routerLink]='' class='menu-toggle nav-link has-dropdown'>  "+
//      "<i data-feather='monitor'></i><span>Dashboard</span></a>  "+
//     "<ul class='dropdown-menu'>  "+

//     "<li> <a [routerLink]='/customer'>customer</a> </li>" +
//     "<li><a [routerLink]='['/menu']' routerLinkActive='active'>Menu Test</a></li>" +

//     "</ul>  "+
//   "</li>  "+
// "</ul>" ;


    
    
    // this.html = "<ul class='sidebar-menu'> "+
    //                 "<li class='menu-header'>MainTest</li> ";

    //  for (let i = 0; i < this.MainmenuList.length; i++) {
    //     if (this.MainmenuList[i].DocumentParentId == 0) {  

    //         this.html += "<li class='dropdown'> " +
    //                         "<a href='#' class='menu-toggle nav-link has-dropdown'>" +
    //                         "<i data-feather='monitor'></i><span>" + this.MainmenuList[i].DocumentName +"</span></a>"+
    //                             "<ul class='dropdown-menu'>" ;

    //                             for (let j = 0; j < this.DocumentList.length; j++) {
    //                               if (this.MainmenuList[i].DocumentId == this.DocumentList[j].DocumentParentId) { 

    //                                 this.html += "<li><a [routerLink]='['"+ this.DocumentList[j].RouteUrl +"']' class='nav-link' >"+ this.DocumentList[j].DocumentName +"</a></li>";
    //                               }
    //                             }

    //         this.html +=  "</ul>"+
    //                       "</li>";
    //   }
    // }
    // this.html += "</li>"+
    //              "</ul>"

    // return this.html;

  // }


  // GetNewMenuHtml(): String{
  //   this.html = "<ul class='sidebar-menu'> " +
  //   "<ng-container *ngFor = 'let menuItem of MainmenuList; let i=index;'>" +
  //   "<li class='menu-header'>DataBase</li>" +
  //   "<li class='dropdown'>" +
  //     "<a href='#' class='menu-toggle nav-link has-dropdown'><i data-feather='layout'></i><span>Forms</span></a>" +
  //     "<ul class='dropdown-menu'>" +
  //       "<li><a class='nav-link' href='basic-form.html'>Basic Form</a></li>" +
  //       "<li><a class='nav-link' href='forms-advanced-form.html'>Advanced Form</a></li>" +
  //       "<li><a class='nav-link' href='forms-editor.html'>Editor</a></li>" +
  //       "<li><a class='nav-link' href='forms-validation.html'>Validation</a></li>" +
  //       "<li><a class='nav-link' href='form-wizard.html'>Form Wizard</a></li>" +
  //     "</ul>" +
  //   "</li>" +
  //   "</ng-container>" +
  //   "</ul>";

  //   return this.html;
  // }

}
